import { useAuth0 } from '@auth0/auth0-react'
import { useAuth0PermissionLevelLazyQuery } from 'lib/generated/user'
import { useEffect, useState } from 'react'

const useAuth0PermissionLevel = (withLoading = true) => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()
  const [fetchAuth0PermissionLevel, { data, loading }] = useAuth0PermissionLevelLazyQuery()
  const [accessToken, setAccessToken] = useState(null)
  const [userPermission, setUserPermission] = useState<string>('')

  useEffect(() => {
    const fetchAccessToken = async () => {
      if (isAuthenticated) {
        const token = await getAccessTokenSilently()
        setAccessToken(token)
      }
    }

    fetchAccessToken()
  }, [isAuthenticated, getAccessTokenSilently])

  useEffect(() => {
    const fetchUserPermission = () => {
      if (isAuthenticated && accessToken) {
        const email = user.email
        fetchAuth0PermissionLevel({
          variables: {
            email: email,
          },
          fetchPolicy: 'cache-and-network',
          context: {
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
          },
        })
      }
    }

    fetchUserPermission()
  }, [fetchAuth0PermissionLevel, isAuthenticated, accessToken, user])

  useEffect(() => {
    if (!loading && data) {
      setUserPermission(data.auth0PermissionLevel)
    }
  }, [loading, data])

  // return { userPermission, permissionLoading: loading }
  return withLoading ? { userPermission, permissionLoading: loading } : { userPermission }
}

export default useAuth0PermissionLevel
